(function () {
    const checkoutGenerator = (e) => {
        const target = e.target;
        e.preventDefault();
        const bundleContainer = target.closest('[data-type="bundle"]'), bundleDataElement = bundleContainer.querySelector('[data-taste-options]'), bundleData = JSON.parse(bundleDataElement.innerHTML), hintContainer = bundleContainer.querySelector('[data-type="hint"]');
        let checkoutItems = {}, valid = true;
        hintContainer.classList.add('none');
        // Process gifts
        for (const giftId of bundleData.gifts) {
            checkoutItems[giftId] = 1;
        }
        // Process option products
        const optionSelectors = Array.from(bundleContainer.querySelectorAll('select[data-handle]'));
        for (let selectElement of optionSelectors) {
            const selectValue = selectElement.value;
            if (selectValue) {
                const variantId = bundleData.options[selectValue];
                if (checkoutItems[variantId]) {
                    checkoutItems[variantId] += 1;
                }
                else {
                    checkoutItems[variantId] = 1;
                }
                selectElement.classList.remove('invalid');
            }
            else {
                valid = false;
                selectElement.classList.add('invalid');
            }
        }
        // Create cart permalink
        let checkoutUrl = window.routes.cartUrl + '/';
        const keys = Object.keys(checkoutItems);
        for (let i = 0; i < keys.length; i++) {
            checkoutUrl += keys[i] + ':' + checkoutItems[keys[i]];
            if (i < keys.length - 1)
                checkoutUrl += ',';
        }
        if (bundleData.discount) {
            checkoutUrl += '?discount=' + bundleData.discount + '&attributes[_from]=sales-page';
        }
        else {
            checkoutUrl += '?attributes[_from]=sales-page';
        }
        if (bundleData.blockedProductIds) {
            checkoutUrl += '&attributes[_blocked-advantage-packages]=' + bundleData.blockedProductIds;
        }
        if (bundleData.keyword) {
            checkoutUrl += '&attributes[_keyword]=' + encodeURIComponent(bundleData.keyword);
        }
        if (bundleData.abVariant) {
            checkoutUrl += '&attributes[_ab-variant]=' + bundleData.abVariant;
        }
        if (valid) {
            const modalLoadingButton = bundleContainer.querySelector('[data-modal-loading]');
            bundleContainer.closest('.Modal').querySelector('[data-action="close-modal"]').click();
            modalLoadingButton.setAttribute('data-href', checkoutUrl);
            modalLoadingButton.click();
        }
        else {
            hintContainer.classList.remove('none');
        }
    };
    // Add listeners to checkout buttons
    const bundles = document.querySelectorAll('[data-type="bundle"]');
    for (let i = 0; i < bundles.length; i++) {
        const checkoutButton = bundles[i].querySelector('button[data-action="checkout"]');
        if (checkoutButton) {
            checkoutButton.addEventListener('click', checkoutGenerator);
        }
    }
})();
/**
 * Content based on video progress
 */
(function () {
    const videoElement = document.querySelector('.SalesPageHero__VideoWrapper[data-wistia-id]');
    if (videoElement) {
        const wistiaId = videoElement.getAttribute('data-wistia-id'), delay = videoElement.hasAttribute('data-progress-based-content-time') ? parseInt(videoElement.getAttribute('data-progress-based-content-time')) : 0, displaySections = () => {
            videoElement.classList.add('SalesPageHero__VideoWrapper--shrinked');
            document.querySelectorAll('.vsl-none').forEach((section) => {
                section.classList.remove('vsl-none');
                const innerMasonry = section.querySelector('[data-masonry-grid="true"]');
                if (innerMasonry)
                    innerMasonry.dispatchEvent(new CustomEvent('theme:masonry:change'));
            });
            window.dispatchEvent(new Event('resize')); // Trigger resize to allow sliders to recalculate their dimensions
        };
        if (localStorage.getItem(`vsl_${location.pathname.split('/').pop()}_complete`) === 'true') {
            displaySections();
        }
        else {
            const player = document.querySelector(`wistia-player[media-id="${wistiaId}"]`);
            const onSecondChange = (e) => {
                if (e.detail.second >= delay) {
                    displaySections();
                    localStorage.setItem(`vsl_${location.pathname.split('/').pop()}_complete`, 'true');
                    player.cancelFullscreen();
                    player.removeEventListener('second-change', onSecondChange);
                }
            };
            if (delay !== 0) {
                player.addEventListener('second-change', onSecondChange);
            }
            else {
                displaySections();
            }
        }
    }
})();
/**
 * Countdown elements
 */
(function () {
    const countdownElements = document.querySelectorAll('[data-timer-date]');
    if (!countdownElements.length)
        return;
    const search = new URLSearchParams(window.location.search);
    countdownElements.forEach((element) => {
        if (element.getAttribute('data-timer-date') === 'reset') {
            const trafficSources = element.getAttribute('data-timer-traffic-sources') ? element.getAttribute('data-timer-traffic-sources').split(',').map(item => item.trim()) : [], source = search.get('referrer_template');
            console.log("Resetting timer", trafficSources, source);
            if (trafficSources.length && !trafficSources.includes(source))
                return;
            const timerDuration = element.hasAttribute('data-timer-duration') ? parseInt(element.getAttribute('data-timer-duration')) : 48, timerResetDuration = element.hasAttribute('data-timer-reset-duration') ? parseInt(element.getAttribute('data-timer-reset-duration')) : 12, currentDate = new Date(), initialEndDate = new Date(`2025-09-08T23:59:00+${String(new Date().getTimezoneOffset() * -1 / 60).padStart(2, '0')}:00`), diff = currentDate.getTime() - initialEndDate.getTime(), offsetFactor = Math.floor(diff / (1000 * 60 * 60 * (timerDuration - timerResetDuration))), // Reset timer every (timerDuration - timerResetDuration) hours
            endDate = new Date(initialEndDate.getTime() + (offsetFactor * (timerDuration - timerResetDuration) * 60 * 60 * 1000) + (timerDuration * 60 * 60 * 1000));
            element.setAttribute('data-timer-date', `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`);
            element.setAttribute('data-timer-time', `${endDate.getHours().toString().padStart(2, '0')}:${(endDate.getMinutes()).toString().padStart(2, '0')}`);
            const label = element.querySelector('.Timer__Label');
            label.innerText = label.innerText.replace('[date]', endDate.toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })).replace('[time]', `${endDate.getHours().toString().padStart(2, '0')}:${endDate.getMinutes().toString().padStart(2, '0')}`);
            element.closest('.Timer').classList.remove('none');
            element.dispatchEvent(new CustomEvent('theme:timer:init'));
        }
    });
})();
(() => {
    // Hide sticky bar when offer is visible
    const offerSection = document.querySelector('.SalesPageOffer'), stickyCta = document.querySelector('.StickyCta');
    if (stickyCta && offerSection) {
        const observer = new IntersectionObserver(entries => {
            let shouldHide = false;
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    shouldHide = true;
                }
            });
            stickyCta.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
            document.documentElement.style.setProperty('--sticky-cta-height', shouldHide ? '0' : `${stickyCta.offsetHeight}px`);
        }, {
            threshold: 0.2
        });
        observer.observe(offerSection);
        const footer = document.querySelector('#shopify-section-shop-footer');
        if (footer)
            observer.observe(footer);
        const heroCta = document.querySelector('.SalesPageHero a[href*="#angebot"]');
        if (heroCta)
            observer.observe(heroCta);
        document.addEventListener('theme:stickycta:disconnect', () => {
            observer.disconnect();
        });
    }
})();
/**
 * Exit intent survey
 */
(() => {
    const surveyModal = document.querySelector('#modal-sales-page-exit-intent'), modalOpener = document.querySelector('[data-action="open-modal"][aria-controls="modal-sales-page-exit-intent"]'); // Button is needed on page load for ajax modal functionality
    if (sessionStorage.getItem('sales_page_exit_intent_shown') === "true" || !surveyModal || !modalOpener)
        return;
    const handleMouseleave = (e) => {
        if (sessionStorage.getItem('sales_page_exit_intent_shown') === "true") {
            document.body.removeEventListener('mouseleave', handleMouseleave);
            return;
        }
        if (e.clientY < 0) {
            modalOpener.click();
            sessionStorage.setItem('sales_page_exit_intent_shown', "true");
        }
    };
    document.body.addEventListener('mouseleave', handleMouseleave);
})();
/**
 * Review screenshots slider
 */
(() => {
    window.onDomReady(() => {
        const reviewSection = document.querySelector('.ReviewScreenshots'), sliderElement = reviewSection ? reviewSection.querySelector('.Slider') : null;
        if (!reviewSection || !sliderElement || !window.Slider)
            return;
        new Slider(sliderElement);
    });
})();
/**
 * Personalized offer
 */
(() => {
    if (window.salesPageExpired) {
        document.querySelectorAll('[data-offer] [href*="/cart/"]').forEach(button => {
            button.href = button.href.replace(/\?.*/, '');
        });
        return;
    }
    const search = new URLSearchParams(window.location.search);
    for (let i = 1; i <= 3; i++) {
        if (search.has(`discount${i}`)) {
            const cartButtons = document.querySelectorAll(`[data-offer="${i}"] [href*="/cart/"]`);
            cartButtons.forEach(button => {
                button.href = button.href.replace(/discount=[^&]+/, `discount=${search.get(`discount${i}`)}`);
            });
            const modalButtons = document.querySelectorAll(`[data-offer="${i}"] [data-action="open-modal"][aria-controls^="modal-offer"][aria-controls$="${i}"]`);
            modalButtons.forEach(button => {
                const modal = document.getElementById(button.getAttribute('aria-controls')), dataElement = modal.querySelector('[data-products]'), data = JSON.parse(dataElement.getAttribute('data-products'));
                data.discount = search.get(`discount${i}`);
                dataElement.setAttribute('data-products', JSON.stringify(data));
            });
        }
    }
})();
export {};
